import React, { useState, useRef, useEffect } from 'react';
import Background     from 'assets/backgrounds/login-page-bg.png';
import BookdocLogo    from 'assets/logos/Sidebar.svg';
import EmailIcon      from 'assets/icons/Email.png';
import LockIcon       from 'assets/icons/Lock.png';
import Modal          from 'react-bootstrap/Modal';
import CloseBtn       from 'assets/icons/Close.svg';
import Form           from 'react-validation/build/form';
import CheckButton    from 'react-validation/build/button';
import AuthService    from 'services/auth.service';
import queryString    from 'query-string';

export function ForgotPasswordModal() {
  const [show, setShow]                     = useState(false);
  const handleClose                         = () => setShow(false);
  const handleShow                          = () => setShow(true);
  const [forgetEmail, setForgetEmail]       = useState('');
  const [validEmail, setValidEmail]         = useState(false);
  const [successMsg, setSuccessMsg]         = useState('');
  const [errorMsg, setErrorMsg]             = useState('');
  const [disabledSubmit, setDisabledSubmit] = useState(false);

  useEffect(() => {
    const checkValidity = forgetEmail.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/); // eslint-disable-line no-control-regex

    setValidEmail(!!checkValidity);
  }, [forgetEmail]);

  // (?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])
  const submitForgetPassword = () => {
    const parameters = queryString.stringify({
      email: forgetEmail
    });

    setSuccessMsg('');
    setErrorMsg('');
    setDisabledSubmit(true);

    AuthService.forgotPassword(parameters).then(
      (data) => {
        setSuccessMsg(data.messages.join(', '));

        setTimeout(function() {
          setDisabledSubmit(false);
        }, 5000);
      },
      (error) => {
        setErrorMsg(error.response.data.errors.join(', '));
      }
    );
  }

  return (
    <div>
      <a className="text-danger d-block mb-8 clickable font-size-7" href="#forgot-password" onClick={ handleShow }>Forgot Your Password?</a>

      <Modal show={ show } onHide={ handleClose } keyboard={ false } size="lg" centered>
        <Modal.Header className="d-block">
          <h2 className="text-center">Forgot Password</h2>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body className="d-block text-center font-size-7">
          <p className="text-center text-grey mb-10">Enter your email below and we will send you a link to reset your password.</p>

          <div className="mb-14">
            <div className="d-flex justify-content-center">
              <input id="forget-password-field" name="email" type="text" placeholder=" " onChange={(e) => setForgetEmail(e.target.value) } className="form-control rounded-pill w-em-50 mb-6"/>
            </div>

            <p className="text-success mb-0">{ successMsg }</p>
            <p className="text-danger mb-0">{ errorMsg }</p>
          </div>

          <button id="sign-in-btn" className="btn btn-danger text-white rounded-pill py-4 px-20" onClick={() => submitForgetPassword() } disabled={ !validEmail || disabledSubmit }>
            Submit
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
}

const required = (value) => {
  if (!value) {
    return (
      <div className="text-danger mt-2 ml-16 text-left" role="alert">
        This field is required!
      </div>
    );
  }
};

const Login = (props) => {
  const form      = useRef();
  const checkBtn  = useRef();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [message, setMessage]   = useState("");

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(username, password).then(
        (data) => {
          window.location.replace('/eb/select_location');
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);

          if (resMessage === 'Request failed with status code 401') {
            setMessage('Incorrect email or password');
          } else {
            setMessage(resMessage);
          }
        }
      );
    } else {
      setLoading(false);
    }
  };

  return (
    <div id="login-page-bg" className="d-flex justify-content-center" style={{backgroundImage: "url(" + Background + ")"}}>
      <div id="login-white-bg" className="bg-white text-center shadow scrollbar-white">
          <div className="px-6 mb-20">
            <img src={ BookdocLogo } alt="bookdoc-logo" className="w-100"/>
          </div>

          <h2 className="text-grey mb-2">DR. PORTAL</h2>
          <p className="text-grey mb-10 font-size-7">Connecting Patients to Healthcare Profesionals</p>

          <Form onSubmit={ handleLogin } ref={ form }>
            <div className="position-relative w-100 mb-6 font-size-7">
              <img src={ EmailIcon } alt="email-icon" id="email-icon" />

              <input
                type="text"
                className="form-control login-field rounded-pill w-100"
                name="email"
                value={ username }
                onChange={ onChangeUsername }
                validations={ [required] }
                placeholder=" "
              />

              <span className="form-control-label text-lightgrey">Email</span>
            </div>

            <div className="position-relative w-100 mb-4 font-size-7">
              <img src={ LockIcon } alt="lock-icon" id="lock-icon" />

              <input
                type="password"
                className="form-control login-field rounded-pill w-100"
                name="password"
                value={ password }
                onChange={ onChangePassword }
                validations={ [required] }
                placeholder=" "
              />

              <span className="form-control-label text-lightgrey">Password</span>
            </div>

            <ForgotPasswordModal />

            <div className="form-group">
              <button className="btn btn-danger text-white rounded-pill w-100 py-4 font-size-7" id="sign-in-btn" disabled={ loading || !username || !password }>
                { loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}

                <span>Sign In</span>
              </button>
            </div>

            { message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  { message }
                </div>
              </div>
            )}

            {/* Check button is hidden, but it is used for validation. */}
            <CheckButton style={{ display: "none" }} ref={ checkBtn } />
          </Form>

          <p className="mt-8 font-size-6"><a className="text-danger" href="/eb/assistant/login">Click Here</a> For Assistant Login</p>
          <p className="mt-8 font-size-6">Are you a doctor? <a className="text-danger" href="https://sites.bookdoc.com/services/healthcare-professionals/" target="_blank" rel="noreferrer">List your practice on Bookdoc</a></p>
      </div>
    </div>
  )
}

export default Login;